import {
	FormCheckboxList as FormCheckboxListDS,
	type FormCheckboxListProps as FormCheckboxListPropsDS,
} from '@gov-design-system-ce/react-form';
import { MessageWrapper } from './MessageWrapper';

interface FormCheckboxListProps extends Omit<
	FormCheckboxListPropsDS,
	'messageWrapper'
> {}

export const FormCheckboxList = (props: FormCheckboxListProps) => (
	<FormCheckboxListDS
		{...props}
		label={{ size: 'm', ...props.label }}
		messageWrapper={MessageWrapper}
	/>
);
